/**
 * Sanitizes medical/media URLs to handle Mixed Content (http vs https) 
 * and other common display issues.
 */
const OWN_HOST = (import.meta.env.VITE_HOST || "").replace(/^https?:\/\//, "").replace(/\/$/, "");

export const getSafeUrl = (url) => {
  if (!url) return null;

  // Upgrade http to https for our own deployment's domain to prevent Mixed
  // Content blocking. Derived from VITE_HOST (per-deployment) rather than
  // hardcoded domains, so this works for any white-label replica.
  if (url.startsWith('http://') && OWN_HOST && url.includes(OWN_HOST)) {
    return url.replace('http://', 'https://');
  }

  return url;
};
